import { FC } from 'react';
import { IconButton } from '@epam/uui';
import { IModal, useUuiContext } from '@epam/uui-core';
import { FlexRow, Text } from '@epam/promo';
import { ReactComponent as ActionDeleteOutlineIcon } from '@epam/assets/icons/action-delete-outline.svg';
import { ReactComponent as ContentEditOutlineIcon } from '@epam/assets/icons/content-edit-outline.svg';
import { UserGroupEditModal } from '../UserGroupEditModal/UserGroupEditModal';
import css from './UserGroup.module.scss';
import {
  useUpdateRoleNameQuery,
  useRoleDeleteQuery,
} from 'hooks/api/userGroups';
import { useModal } from 'hooks';

interface IRoleLabel {
  id: string;
  name: string;
}

export const RoleLabel: FC<IRoleLabel> = ({ id, name }) => {
  const modal = useModal();
  const { uuiModals } = useUuiContext();
  const { mutate: renameRole } = useUpdateRoleNameQuery();
  const { mutate: deleteRole } = useRoleDeleteQuery();

  const onConfirmChangeName = (newName: string) => {
    renameRole({ roleId: id, newName });
  };

  const handleRemoveRole = () => {
    modal.confirm({
      text: 'Are you sure you want to delete this role?',
      onSuccess: () => {
        deleteRole({ roleId: id });
      },
    });
  };

  const handleEditRole = () => {
    uuiModals
      .show<void>((modalProps: IModal<void>) => (
        <UserGroupEditModal
          confirmCaption="Save"
          helperText="Role name"
          initialValue={name}
          modalProps={modalProps}
          placeholder="Enter role name"
          title={`Edit ${name}`}
          onConfirm={onConfirmChangeName}
        />
      ))
      .catch((e) => console.error(e));
  };

  return (
    <FlexRow cx={css.roleLabel}>
      <Text>{name}</Text>
      <FlexRow cx={css.roleActions}>
        <IconButton
          icon={ContentEditOutlineIcon}
          size="18"
          onClick={handleEditRole}
        />
        <IconButton
          icon={ActionDeleteOutlineIcon}
          size="18"
          onClick={handleRemoveRole}
        />
      </FlexRow>
    </FlexRow>
  );
};
